import React from 'react';

export const ChevronRightIcon = ({ size = 24, color = 'currentColor', rotate = 0, style, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ transform: `rotate(${rotate}deg)`, transition: 'transform 180ms ease', ...style }}
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.62202 20.2252C7.32912 19.9323 7.32912 19.4574 7.62201 19.1645L14.7865 12L7.62201 4.8355C7.32912 4.54261 7.32912 4.06774 7.62201 3.77485C7.91491 3.48195 8.38978 3.48195 8.68267 3.77485L16.9078 12L8.68268 20.2252C8.38978 20.518 7.91491 20.518 7.62202 20.2252Z"
      fill={color}
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/assets/icons/ChevronRight.icon.jsx